import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const l = r((i, e) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: e,
    ...i,
    image: (c) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...c,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4144)", children: [
            /* @__PURE__ */ s.jsx(
              "mask",
              {
                id: "mask0_2974_4144",
                width: 32,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M15.46 12.74a1.42 1.42 0 1 0 0-2.84 1.42 1.42 0 0 0 0 2.84M27.8 14.64c1.83 0 3.32-1.49 3.32-3.32S29.63 8 27.8 8s-3.32 1.49-3.32 3.32 1.49 3.32 3.32 3.32m0-5.14c1 0 1.82.82 1.82 1.82s-.82 1.82-1.82 1.82-1.82-.82-1.82-1.82.82-1.82 1.82-1.82M17.63 22.17c.41 0 .75-.34.75-.75 0-1 .82-1.82 1.82-1.82s1.82.82 1.82 1.82c0 .41.34.75.75.75s.75-.34.75-.75c0-1.83-1.49-3.32-3.32-3.32s-3.32 1.49-3.32 3.32c0 .41.34.75.75.75M32.54 20.98a1.419 1.419 0 1 0-1.42-1.42c-.01.79.63 1.42 1.42 1.42M39.78 23.55a.75.75 0 0 0-.53-.22H11.79c-.41 0-.75.34-.75.75s.34.75.75.75h26.69C38.06 32.43 31.72 38.5 24 38.5c-7.97 0-14.48-6.47-14.5-14.42a.749.749 0 1 0-1.5 0C8.03 32.86 15.2 40 24 40s15.97-7.14 16-15.92c0-.2-.08-.39-.22-.53"
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4144)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M1.602 1.533h44.69V45.59H1.602z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4144", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
l.displayName = "AgencyMixIngredientsIcon";
export {
  l as AgencyMixIngredientsIcon,
  l as default
};
//# sourceMappingURL=index.js.map
